class AnnouncementBarChroxel {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('.announcement-bar-chroxel__track');
    this.messages = container.querySelectorAll('.announcement-bar-chroxel__message');
    this.arrows = container.querySelectorAll('.announcement-bar-chroxel__arrow');
    this.index = 0;
    this.length = this.messages.length;
    this.interval = null;
    this.delay = 4000;

    if (this.length <= 1) {
      this.arrows.forEach((arrow) => {
        arrow.style.display = 'none';
      });
      return;
    }

    this.messageHeight = this.messages[0].offsetHeight || 40;
    this.updateHeight();

    this.arrows.forEach((arrow) => {
      arrow.addEventListener('click', () => {
        const dir = arrow.dataset.dir === 'next' ? 1 : -1;
        this.goTo(this.index + dir);
        this.resetAutoplay();
      });
    });

    this.container.addEventListener('mouseenter', () => this.pause());
    this.container.addEventListener('mouseleave', () => this.play());
    this.container.addEventListener('focusin', () => this.pause());
    this.container.addEventListener('focusout', () => this.play());

    window.addEventListener('resize', () => {
      this.messageHeight = this.messages[0].offsetHeight || 40;
      this.updateHeight();
    });

    this.play();
  }

  updateHeight() {
    this.track.style.transform = `translate3d(0, -${this.index * this.messageHeight}px, 0)`;
  }

  goTo(index) {
    this.index = (index + this.length) % this.length;
    this.updateHeight();
  }

  play() {
    if (this.interval) return;
    this.interval = setInterval(() => {
      this.goTo(this.index + 1);
    }, this.delay);
  }

  pause() {
    if (!this.interval) return;
    clearInterval(this.interval);
    this.interval = null;
  }

  resetAutoplay() {
    this.pause();
    this.play();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.announcement-bar-chroxel').forEach((el) => {
    new AnnouncementBarChroxel(el);
  });
});
